import {useEffect} from 'react';
import {useMediaQuery} from 'react-responsive';
import moment from 'moment';
import useStore from '../../store/store';
import breakpoints from './breakpoints';
import lscache from 'lscache';
import {useLocation} from 'react-router-dom';
import usePersistentAuthStore from '../../store/persistentAuthStore';
import {getReviewUsPopupLsKeys} from '../subcomponents/ReviewUsPopup';
import {MINIMUM_ACCOUNT_AGE_DAYS, REVIEW_US_POPUP_DELAY_MS} from './popupsConfig';

// Component itself renders nothing, but it's used to control the state of the popups

export function PopupsLogic() {
  const setState = useStore(state => state.setState);
  const visiblePopup = useStore(state => state.visiblePopup);
  const {auth} = usePersistentAuthStore();
  const isMobile = useMediaQuery({query: breakpoints.mobile});
  const location = useLocation();

  const reviewUsLsKeys = auth ? getReviewUsPopupLsKeys(auth.accountId) : {};
  const isEligibleForReviewUsPopup = Boolean(
    auth &&
    !auth.wb_auth &&
    auth.username !== 'demo' &&
    !auth.menu.error &&
    auth.review_us_popup === 1 &&
    moment().diff(auth.creationDate, 'days') >= MINIMUM_ACCOUNT_AGE_DAYS &&
    !lscache.get(reviewUsLsKeys.dismissed) &&
    !lscache.get(reviewUsLsKeys.completed)
  );

  useEffect(() => {
    if (visiblePopup === 'reviewus') return;

    // Remove any existing popup
    setState('visiblePopup', null);

    // Stop logic if user is: not logged in OR user logged in via WB OR user is on mobile OR user is demo account or menu structure is not received
    if (!auth || auth.wb_auth || auth.username === 'demo' || auth.menu.error) return;

    // If user has not accepted privacy policy and has no custom T&C, show the privacy policy popup
    if (auth.has_custom_tos === 0 && auth.standard_tos_accepted === 0) {
      return setState('visiblePopup', 'policy');
    }

    // If onboarding enabled and user has not completed it and user is not using mobile, start onboarding
    if (
      auth.onboarding_enabled === 1 &&
      !auth.onboarding_completed &&
      !isMobile &&
      //!location?.pathname.includes('knowledge-base') &&
      !location?.pathname.includes('prebid-panel')
    ) {
      return setState('visiblePopup', 'onboarding');
    }

    // if (auth.ads_txt_popup === 1) {
    //   return setState('visiblePopup', 'adstxt');
    // }
  }, [auth, isMobile, setState, location, visiblePopup]);

  useEffect(() => {
    if (!isEligibleForReviewUsPopup || visiblePopup) return;

    const timeoutId = setTimeout(() => {
      setState('visiblePopup', 'reviewus');
    }, REVIEW_US_POPUP_DELAY_MS);

    return () => clearTimeout(timeoutId);
  }, [isEligibleForReviewUsPopup, visiblePopup, setState]);

  return null;
}
